import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { formValueSelector, reduxForm } from 'redux-form';
import { toast } from 'react-toastify';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { errorToast } from 'Common/ToastHelper';
import { Filter, Main } from 'Containers';
import { LoadingPage } from 'Components';
import { SelectField } from 'Common/SemanticWrapper';
import { resetForm } from 'State/forms/actions';
import { PrintBarcodeEnum, FilterEnum } from 'Common/FieldEnum';
import { CK_PRINT_BARCODES_FORM_NAME } from 'Common/FormEnum';
import { PrintSortTypeEnum } from 'Common/Constants/Enumeration/CommonEnum';
import { GenericEnum } from 'Common/Constants/Enumeration/CommonEnum';
import {
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
} from 'State/filters/actions';
import { resetDirty } from 'State/dirtyTracking/actions';
import { getIds } from 'Common/FormHelper';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import { ReportGeneration } from 'Common/ObjectHelper';
import * as FilterSelectors from 'State/filters/selectors';

import {
  getItemList,
  setItemsIds,
  printBarcodeData,
  clearPrintBarcodeError,
  setFilteredItemListData,
} from './../../state/printBarcodes/action';
import * as PrintBarcodeSelectors from '../../state/printBarcodes/selectors';
import PrintBarcodesComponent from '../components/PrintBarcodesComponent';

class PrintBarcodeContainer extends Component {
  static propTypes = {
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getVendorForCurrentSite: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    getItemList: PropTypes.func.isRequired,
    printBarcodeData: PropTypes.func.isRequired,
    clearPrintBarcodeError: PropTypes.func.isRequired,
    setItemsIds: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    itemListData: PropTypes.array,
    assignItemsItemGroupData: PropTypes.array.isRequired,
    assignItemsVendorData: PropTypes.array.isRequired,
    initialValues: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
    printLoading: PropTypes.bool.isRequired,
    fetchingDropdown: PropTypes.bool.isRequired,
    printError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    printData: PropTypes.string,
    sortOptionsValue: PropTypes.number,
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    vendorDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemListingError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  };

  static defaultProps = {
    itemListData: [],
    printError: null,
    itemGroupDataError: null,
    vendorDataError: null,
    printData: null,
    sortOptionsValue: PrintSortTypeEnum.ItemCode,
    itemListingError: null,
  };

  reactTableRef = React.createRef();
  state = {
    selectedSortOption: PrintSortTypeEnum.ItemCode,
    filterValues: {
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
    },
    activeIndexes: [0, 1],
    sorted: [],
    filtered: [],
    toggleSelected: false,
  };

  sortOptions = [
    { value: 0, label: 'Item Code' },
    { value: 1, label: 'Item Description' },
  ];

  async componentDidMount() {
    const {
      getItemGroupForCurrentSite,
      getVendorForCurrentSite,
      resetDirty,
    } = this.props;

    getItemGroupForCurrentSite();
    getVendorForCurrentSite();
    await this.props.getItemList(false);
    const { itemListData } = this.props;
    this.props.setItemsIds(itemListData.length ? getIds(itemListData) : []);
    const filteredItems = _.filter(this.props.itemListData, item => {
      return item.UPC;
    });
    this.props.setFilteredItemListData(filteredItems);
    resetDirty();
  }

  componentDidUpdate(prevProps) {
    const { clearPrintBarcodeError, printData } = this.props;
    if (
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'itemListingError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError')
    ) {
      clearPrintBarcodeError();
    }
    if (printData && printData !== prevProps.printData) {
      ReportGeneration(printData, 'Print Barcodes');
      clearPrintBarcodeError();
    }
  }

  componentWillUnmount() {
    toast.dismiss();
  }

  getMainProps = () => {
    const { printLoading, loading } = this.props;
    return {
      toolbox: {
        rightButtons: [
          {
            content: 'Print',
            onClick: this.printReport,
            type: 'button',
            loading: printLoading,
            disabled: loading || printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  printReport = () => {
    const itemArray = this.getFilteredSelectedItem();
    const { selectedSortOption, toggleSelected } = this.state;
    const filtersOptions = {
      ids: itemArray,
      exludeUPC: toggleSelected,
      sortType: selectedSortOption,
    };
    this.props.printBarcodeData(filtersOptions);
  };

  setSortByOption = value => {
    this.setState({
      selectedSortOption: value,
    });
  };

  handleChange = (e, values) => {
    this.setState({ filterValues: values });
  };

  getFilterData = () => {
    this.props.getItemList(this.state.toggleSelected);
  };

  clearFilters = () => {
    this.completeReset();
    this.setState(
      {
        filtered: [],
        sorted: [],
        toggleSelected: false,
        filterValues: {
          [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
          [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
        },
        selectedSortOption: PrintSortTypeEnum.ItemCode,
      },
      () => this.getFilterData()
    );
  };

  completeReset = () => {
    this.props.resetForm(CK_PRINT_BARCODES_FORM_NAME);
  };

  handleClick = (e, titleProps) => {
    const { index } = titleProps;
    const { activeIndexes } = this.state;
    const activeIndexesClone = [...this.state.activeIndexes];
    activeIndexes.indexOf(index) !== -1
      ? activeIndexesClone.splice(activeIndexes.indexOf(index), 1)
      : activeIndexesClone.push(index);
    this.setState({ activeIndexes: activeIndexesClone });
  };

  onSortedChange = sorted => {
    this.setState({ sorted });
  };

  onFilteredChange = filtered => {
    this.setState({ filtered });
  };

  getFilteredSelectedItem = () => {
    const { itemListData, itemIdArray } = this.props;
    const checkedItemOrders = [];
    const dataObjs =
      this.reactTableRef && this.reactTableRef.current
        ? this.reactTableRef.current.getResolvedState()
        : { sortedData: itemListData };
    if (itemIdArray && itemIdArray.length) {
      _.forEach(dataObjs.sortedData, obj => {
        const id = obj[PrintBarcodeEnum.ItemId]
          ? obj[PrintBarcodeEnum.ItemId]
          : obj._original[PrintBarcodeEnum.ItemId];
        if (itemIdArray.indexOf(id) !== -1) {
          checkedItemOrders.push(id);
        }
      });
    } else {
      checkedItemOrders.push(dataObjs.sortedData[0][PrintBarcodeEnum.ItemId]);
    }
    return checkedItemOrders;
  };

  setItemsWithoutUPC = (e, flag) => {
    this.setState(
      {
        toggleSelected: flag,
      },
      () => this.getFilterData()
    );
  };

  render() {
    const {
      assignItemsItemGroupData,
      assignItemsVendorData,
      sortOptionsValue,
      fetchingDropdown,
      itemListData,
      loading,
    } = this.props;
    const { filterValues, toggleSelected } = this.state;
    const fields = [
      {
        name: FilterEnum.GroupId_Item,
        component: SelectField,
        type: 'text',
        options: assignItemsItemGroupData,
        label: 'ITEM GROUP',
      },
      {
        name: FilterEnum.VendorId,
        component: SelectField,
        type: 'text',
        options: assignItemsVendorData,
        label: 'DISTRIBUTOR',
      },
    ];

    const filterValuesData = {};
    _.map(filterValues, (value, key, items) => {
      if (+items[key]) {
        filterValuesData[key] = items[key];
      }
    });
    const filteredData = Object.keys(filterValuesData).length
      ? _.filter(itemListData, filterValuesData)
      : itemListData;

    return fetchingDropdown ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={'Print Barcodes'} />
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          <PrintBarcodesComponent
            fields={fields}
            handleChange={this.handleChange}
            filterValues={this.state.filterValues}
            clearFilters={this.clearFilters}
            sortOptionsValue={sortOptionsValue}
            setSortByOption={this.setSortByOption}
            onChangeOfDT={this.onChangeOfDT}
            activeIndexes={this.state.activeIndexes}
            handleClick={this.handleClick}
            onSortedChange={this.onSortedChange}
            onFilteredChange={this.onFilteredChange}
            sorted={this.state.sorted}
            filtered={this.state.filtered}
            reactTableRef={this.reactTableRef}
            setItemsWithoutUPC={this.setItemsWithoutUPC}
            itemListData={filteredData}
            toggleSelected={toggleSelected}
            sortOptions={this.sortOptions}
            loading={loading}
          />
        </Main>
      </Fragment>
    );
  }
}

const selector = formValueSelector(CK_PRINT_BARCODES_FORM_NAME);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(getIsDirty(CK_PRINT_BARCODES_FORM_NAME)(state));
  return {
    initialValues: {
      [FilterEnum.GroupId_Item]: GenericEnum.InitialFilterValue,
      [FilterEnum.VendorId]: GenericEnum.InitialFilterValue,
      SortOptions: PrintSortTypeEnum.ItemCode,
    },
    itemIdArray: selector(state, PrintBarcodeEnum.ItemListInfo),
    itemListData: PrintBarcodeSelectors.getItemListData(state),
    loading: PrintBarcodeSelectors.getLoading(state),
    printLoading: PrintBarcodeSelectors.getPrintLoading(state),
    printError: PrintBarcodeSelectors.getPrintError(state),
    printData: PrintBarcodeSelectors.getPrintData(state),
    itemListingError: PrintBarcodeSelectors.getItemListingError(state),
    fetchingDropdown:
      FilterSelectors.getItemGroupDataLoading(state) ||
      FilterSelectors.getVendorDataLoading(state),
    assignItemsItemGroupData: FilterSelectors.selectItemGroupData(state),
    assignItemsVendorData: FilterSelectors.selectVendorData(state),
    sortOptionsValue: selector(state, PrintBarcodeEnum.SortOptions),
    isIncludeUPC: selector(state, PrintBarcodeEnum.CurrentUpcItems),
    itemGroupDataError: FilterSelectors.getItemGroupDataError(state),
    vendorDataError: FilterSelectors.getVendorDataError(state),
  };
};

const mapDispatchToProps = {
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
  resetForm,
  getItemList,
  printBarcodeData,
  clearPrintBarcodeError,
  setItemsIds,
  resetDirty,
  setFilteredItemListData,
};

PrintBarcodeContainer = reduxForm({
  enableReinitialize: true,
  destroyOnUnmount: false,
  form: CK_PRINT_BARCODES_FORM_NAME,
})(PrintBarcodeContainer);

export const printbarcodes = connect(
  mapStateToProps,
  mapDispatchToProps
)(PrintBarcodeContainer);



// WEBPACK FOOTER //
// ./src/pages/utilities/printbarcodes/containers/PrintBarcodeContainer.js